module.exports = __webpack_public_path__ + "static/media/affiliate_slider_1.fe260f25.svg";